import { ManipulateType } from 'dayjs'

/**
 * Constantes globales del sistema: catalogos, formatos, estatus, colores, permisos y mapas.
 * Agrupa:
 * - AppConstantes: valores CVE/DESC para autorizaciones, tareas, condicionantes, recordatorios, formatos de fecha, estatus, periodicidades, etc.
 * - AppCodigosCatalogo: claves de catalogos del backend.
 * - AppCatalogos: opciones estaticas (meses, estatus calendario, tipos grafica).
 * - AppMapas: mapeos de codigo a color/clase CSS/display.
 * - AppOrdenamiento: atributos de ordenamiento por modulo.
 */

const formatoFechaYYYYMMDD = 'YYYY-MM-DD'

const descEstatusEnProceso = 'En proceso'
const estatusEnProceso = 'EN_PROCESO'

const colorSuccess = 'success'
const colorLightSuccess = 'light-success'
const colorDanger = 'danger'
const colorLightDanger = 'light-danger'
const colorDark = 'dark'
const colorLightDark = 'light-dark'
const colorNeonCarrot = 'neon-carrot'
const colorLightNeonCarrot = 'light-neon-carrot'

export const AppConstantes = {
  // TIPO RECORDATORIO
  CVE_RECORDATORIO_TAREA: 'TAREA',
  CVE_RECORDATORIO_AUTORIZACION: 'AUTORIZACION',

  //TIPO_INPUT_FILTRO
  CVE_INPUT_TAREA: 'TAREA',
  CVE_INPUT_CONDICIONANTE: 'CONDICIONANTE',

  //TIPO REPORTE
  CVE_REPORTE_TIPO_TAREA: 'TAREA',
  DESC_REPORTE_TIPO_TAREA: 'tarea',
  CVE_REPORTE_TIPO_AUTORIZACION: 'AUTORIZACION',
  DESC_REPORTE_TIPO_AUTORIZACION: 'autorizacion',
  CVE_REPORTE_TIPO_CONDICIONANTE: 'CONDICIONANTE',
  DESC_REPORTE_TIPO_CONDICIONANTE: 'condicionante',

  //FORMATO FECHA
  FORMATO_FECHA: 'DD/MMM/YYYY',
  FORMATO_FECHA_CALCULO_ANIO_MES_DIA: 'DD/MM/YYYY',
  FORMATO_FECHA_GET: formatoFechaYYYYMMDD,
  FORMATO_FECHA_POST: formatoFechaYYYYMMDD,
  FORMATO_FECHA_RECORDATORIO_POST: 'YYYY-MM-DD HH:mm:ss',
  FORMATO_FECHA_RECORDATORIO_REFERENCIA_POST: formatoFechaYYYYMMDD,
  FORMATO_FECHA_CALENDARIO_SEMANAL_GET: formatoFechaYYYYMMDD,
  FORMATO_FECHA_RANGO_CALENDARIO: formatoFechaYYYYMMDD,

  //FORMATO FECHA PRELLENADO FIREFOX Y CHROME
  FORMATO_FECHA_FIREFOX_CHROME: 'YYYY-MM-DDTHH:mm:ss',

  //TIPO FILTRO
  FILTRO_TEXT: 'text',
  FILTRO_FECHA: 'fecha',
  FILTRO_SELECT: 'select',

  //ESTATUS AUTORIZACION
  CVE_ESTATUS_AUTORIZACION_VIGENTE: 'VIGENTE',
  DESC_ESTATUS_AUTORIZACION_VIGENTE: 'Vigente',
  CVE_ESTATUS_AUTORIZACION_VENCIDA: 'VENCIDA',
  DESC_ESTATUS_AUTORIZACION_VENCIDA: 'Vencida',
  CVE_ESTATUS_AUTORIZACION_BAJA: 'BAJA',
  DESC_ESTATUS_AUTORIZACION_BAJA: 'Baja',
  CVE_ESTATUS_AUTORIZACION_EN_PROCESO_RENOVACION: 'EN_PROCESO_RENOVACION',
  DESC_ESTATUS_AUTORIZACION_EN_PROCESO_RENOVACION: 'En proceso de renovación',

  //UNIDAD_RECORDATORIO_PERSONALIZADA:
  CVE_UNIDAD_RECORDATORIO_PERSONALIZADO: 'PERSONALIZADO',
  DESC_UNIDAD_RECORDATORIO_PERSONALIZADO: 'Personalizado',

  //UNIDAD DE RECORDATORIO AUTORIZACION
  CVE_UNIDAD_AUTORIZACION_RECORDATORIOS_ANIOS: 'ANIOS',
  DESC_UNIDAD_AUTORIZACION_RECORDATORIOS_ANIOS: 'Años',
  CVE_UNIDAD_AUTORIZACION_RECORDATORIOS_MESES: 'MESES',
  DESC_UNIDAD_AUTORIZACION_RECORDATORIOS_MESES: 'Meses',
  CVE_UNIDAD_AUTORIZACION_RECORDATORIOS_DIAS: 'DIAS',
  DESC_UNIDAD_AUTORIZACION_RECORDATORIOS_DIAS: ' Dias',
  CVE_UNIDAD_AUTORIZACION_RECORDATORIOS_HORAS: 'HORAS',
  DESC_UNIDAD_AUTORIZACION_RECORDATORIOS_HORAS: 'Horas',
  CVE_UNIDAD_AUTORIZACION_RECORDATORIOS_MINUTOS: 'MINUTOS',
  DESC_UNIDAD_AUTORIZACION_RECORDATORIOS_MINUTOS: 'Minutos',

  //RECORDATORIO GUARDAR O ACTUALIZAR
  CVE_RECORDATORIO_GUARDAR: 'GUARDAR',
  CVE_RECORDATORIO_ACTUALIZAR: 'ACTUALIZAR',

  //UNIDAD DURACION AUTORIZACION
  //PERIODICIDAD
  CVE_UNIDAD_DURACION_AUTORIZACION_DIAS: 'DIAS',
  DESC_UNIDAD_DURACION_AUTORIZACION_DIAS: ' días',
  CVE_UNIDAD_DURACION_AUTORIZACION_ANIOS: 'ANIOS',
  DESC_UNIDAD_DURACION_AUTORIZACION_ANIOS: ' años',
  CVE_UNIDAD_DURACION_AUTORIZACION_MESES: 'MESES',
  DESC_UNIDAD_DURACION_AUTORIZACION_MESES: ' meses',

  //ESTATUS CONDICIONANTE
  CVE_ESTATUS_CONDICIONANTE_EN_PROCESO: estatusEnProceso,
  DESC_ESTATUS_CONDICIONANTE_EN_PROCESO: 'En proceso',
  CVE_ESTATUS_CONDICIONANTE_COMPLETADA: 'COMPLETADA',
  DESC_ESTATUS_CONDICIONANTE_COMPLETADA: 'Completada',
  CVE_ESTATUS_CONDICIONANTE_VENCIDA: 'VENCIDA',
  DESC_ESTATUS_CONDICIONANTE_VENCIDA: 'Vencida',
  CVE_ESTATUS_CONDICIONANTE_BAJA: 'BAJA',
  DESC_ESTATUS_CONDICIONANTE_BAJA: 'Baja',

  //ETAPA CONDICIONANTE
  CVE_ETAPA_CONDICIONANTE_EN_PROCESO: estatusEnProceso,
  DESC_ETAPA_CONDICIONANTE_EN_PROCESO: descEstatusEnProceso,
  CVE_ETAPA_CONDICIONANTE_VENCIDA: 'VENCIDA',
  DESC_ETAPA_CONDICIONANTE_VENCIDA: 'Vencida',
  CVE_ETAPA_CONDICIONANTE_FINALIZADA: 'FINALIZADA',
  DESC_ETAPA_CONDICIONANTE_FINALIZADA: 'Finalizada',

  //PERIODICIDAD CONDICIONANTE

  CVE_PERIODICIDAD_CONDICIONANTE_DIARIA: 'DIARIA',
  DESC_PERIODICIDAD_CONDICIONANTE_DIARIA: 'Diaria',
  CVE_PERIODICIDAD_CONDICIONANTE_SEMANAL: 'SEMANAL',
  DESC_PERIODICIDAD_CONDICIONANTE_SEMANAL: 'Semanal',
  CVE_PERIODICIDAD_CONDICIONANTE_MENSUAL: 'MENSUAL',
  DESC_PERIODICIDAD_CONDICIONANTE_MENSUAL: 'Mensual',
  CVE_PERIODICIDAD_CONDICIONANTE_TRIMESTRAL: 'TRIMESTRAL',
  DESC_PERIODICIDAD_CONDICIONANTE_TRIMESTRAL: 'Trimestral',
  CVE_PERIODICIDAD_CONDICIONANTE_SEMESTRAL: 'SEMESTRAL',
  DESC_PERIODICIDAD_CONDICIONANTE_SEMESTRAL: 'Semestral',
  CVE_PERIODICIDAD_CONDICIONANTE_ANUAL: 'ANUAL',
  DESC_PERIODICIDAD_CONDICIONANTE_ANUAL: 'Anual',
  CVE_PERIODICIDAD_CONDICIONANTE_UNICA: 'UNICA',
  DESC_PERIODICIDAD_CONDICIONANTE_UNICA: 'Única',

  //PRIORIDAD CONDICIONANTE
  CVE_PRIORIDAD_CONDICIONANTE_ALTA: 'ALTA',
  DESC_PRIORIDAD_CONDICIONANTE_ALTA: 'Alta',
  CVE_PRIORIDAD_CONDICIONANTE_MEDIA: 'MEDIA',
  DESC_PRIORIDAD_CONDICIONANTE_MEDIA: 'Media',
  CVE_PRIORIDAD_CONDICIONANTE_BAJA: 'BAJA',
  DESC_PRIORIDAD_CONDICIONANTE_BAJA: 'Baja',

  //ESTATUS TAREAS
  CVE_ESTATUS_TAREA_EN_PROCESO: 'EN_PROCESO',
  DESC_ESTATUS_TAREA_EN_PROCESO: 'En proceso',
  CVE_ESTATUS_TAREA_COMPLETADA: 'COMPLETADA',
  DESC_ESTATUS_TAREA_COMPLETADA: 'Completada',
  CVE_ESTATUS_TAREA_VENCIDA: 'VENCIDA',
  DESC_ESTATUS_TAREA_VENCIDA: 'Vencida',
  CVE_ESTATUS_TAREA_CANCELADA: 'CANCELADA',
  DESC_ESTATUS_TAREA_CANCELADA: 'Cancelada',
  CVE_ESTATUS_TAREA_BAJA: 'BAJA',
  DESC_ESTATUS_TAREA_BAJA: 'Baja',
  CVE_ESTATUS_TAREA_POR_INICIAR: 'POR_INICIAR',
  DESC_ESTATUS_TAREA_POR_INICIAR: 'Por iniciar',

  //PRIORIDAD TAREA
  CVE_PRIORIDAD_TAREA_ALTA: 'ALTA',
  DESC_PRIORIDAD_TAREA_ALTA: 'Alta',
  CVE_PRIORIDAD_TAREA_MEDIA: 'MEDIA',
  DESC_PRIORIDAD_TAREA_MEDIA: 'Media',
  CVE_PRIORIDAD_TAREA_BAJA: 'BAJA',
  DESC_PRIORIDAD_TAREA_BAJA: 'Baja',

  //PERIODICIDAD GENERAL
  CVE_PERIODICIDAD_NULL: '',
  DESC_PERIODICIDAD_NULL: 'Única vez',
  CVE_PERIODICIDAD_UNICAVEZ: 'UNICAVEZ',
  DESC_PERIODICIDAD_UNICAVEZ: 'Única vez',
  CVE_PERIODICIDAD_DIARIA: 'DIARIA',
  DESC_PERIODICIDAD_DIARIA: 'Diaria',
  CVE_PERIODICIDAD_SEMANAL: 'SEMANAL',
  DESC_PERIODICIDAD_SEMANAL: 'Semanal',
  CVE_PERIODICIDAD_MENSUAL: 'MENSUAL',
  DESC_PERIODICIDAD_MENSUAL: 'Mensual',
  CVE_PERIODICIDAD_BIMESTRAL: 'BIMESTRAL',
  DESC_PERIODICIDAD_BIMESTRAL: 'Bimestral',
  CVE_PERIODICIDAD_TRIMESTRAL: 'TRIMESTRAL',
  DESC_PERIODICIDAD_TRIMESTRAL: 'Trimestral',
  CVE_PERIODICIDAD_SEMESTRAL: 'SEMESTRAL',
  DESC_PERIODICIDAD_SEMESTRAL: 'Semanal',
  CVE_PERIODICIDAD_ANUAL: 'ANUAL',
  DESC_PERIODICIDAD_ANUAL: 'Anual',

  //UNIDAD DURACIÓN GENERAL
  //modificado para calculoUtils
  CVE_UNIDAD_DURACION_DIAS: 'DIARIA',
  DESC_UNIDAD_DURACION_DIAS: 'Diaria',
  CVE_UNIDAD_DURACION_SEMANAS: 'SEMANAL',
  DESC_UNIDAD_DURACION_SEMANAS: 'Semanal',
  CVE_UNIDAD_DURACION_MESES: 'MENSUAL',
  DESC_UNIDAD_DURACION_MESES: 'Mensual',
  CVE_UNIDAD_DURACION_ANIOS: 'ANUAL',
  DESC_UNIDAD_DURACION_ANIOS: 'Anual',

  //UNIDAD DURACIÓN AUTORIZACION
  CVE_UNIDAD_DURACION_DIAS_AUTORIZACION: 'DIAS',
  DESC_UNIDAD_DURACION_DIAS_AUTORIZACION: 'Días',
  CVE_UNIDAD_DURACION_SEMANAS_AUTORIZACION: 'SEMANAS',
  DESC_UNIDAD_DURACION_SEMANAS_AUTORIZACION: 'Semanas',
  CVE_UNIDAD_DURACION_MESES_AUTORIZACION: 'MESES',
  DESC_UNIDAD_DURACION_MESES_AUTORIZACION: 'Meses',
  CVE_UNIDAD_DURACION_ANIOS_AUTORIZACION: 'ANIOS',
  DESC_UNIDAD_DURACION_ANIOS_AUTORIZACION: 'Años',

  CLAVE_NIVEL_CONDICIONANTE: 'condicionante',
  CLAVE_NIVEL_AUTORIZACION: 'autorizacion',
  CLAVE_NIVEL_GENERAL: 'general',

  //TAB_MODAL_CONDICIONANTE
  CVE_TAB_RECORDATORIOS_RECURRENTES: 'RECORDATORIOS_RECURRENTES',
  CVE_TAB_TAREAS: 'TAREAS',
  CVE_TAB_REPORTES: 'REPORTES',

  //TIPO SWALFIRE
  DESC_EXITOGUARDAR_AUTORIZACION: 'ExitoGuardarAutorizacion',
  DESC_ERRORGUARDARACTUALIZAR_AUTORIZACION: 'ErrorGuardarActualizarAutorizacion',

  // PERFIL USUARIO
  CVE_PERFIL_ADMINISTRADOR: 'ADMINISTRADOR',
  CVE_PERFIL_OPERACION: 'OPERACION',
  CVE_PERFIL_RESPONSABLE_OPERACION: 'RESPONSABLE_OPERACION',

  DESC_EXITOGUARDAR_CONDICIONANTE: 'ExitoGuardarCondicionante',
  DESC_EXITOACTUALIZAR_CONDICIONANTE: 'ExitoActualizarCondicionante',
  DESC_ERRORGUARDARACTUALIZAR_CONDICIONANTE: 'ErrorGuardarActualizarCondicionante',
  DESC_EXITOGUARDARACTUALIZAR_CONDICIONANTE_SINREPORTES:
    'ErrorGuardarActualizarCondicionanteSinReportes',

  //ESTATUS_TAREA_POR_ASIGNAR
  CLAVE_ESTATUS_TAREA_POR_ASIGNAR: 'POR_ASIGNAR',

  //VALOR DE USUARIO SIN ASIGNAR EN TAREAS
  CVE_USUARIO_TAREAS_SIN_ASIGNAR: 'SIN_ASIGNAR',
  DESC_USUARIO_TAREAS_SIN_ASIGNAR: 'Sin usuario asignado',

  //CATALOGOS SELECCIONADOS
  CAT_CODE_AUTORIZACION: 'AUTORIZACION',
  DESC_AUTORIZACION: 'Autorización',
  CAT_CODE_RAZON_SOCIAL: 'RAZON_SOCIAL',
  DESC_RAZON_SOCIAL: 'Razón Social',
  CAT_CODE_PROCESO_ACTIVIDAD: 'PROCESO_ACTIVIDAD',
  DESC_PROCESO_ACTIVIDAD: 'Actividad',
  CAT_CODE_POSICION_CONTACTO: 'POSICION_CONTACTO',
  DESC_POSICION_CONTACTO: 'Posición',
  CAT_CODE_LAB_GESTION_OPCIONES: 'LAB_GESTION_OPCIONES',
  DESC_LAB_GESTION_OPCIONES: 'Lab Gestión Opciones',
  CAT_CODE_undefined: 'undefined',
  DESC_undefined: 'undefined',

  //TAREA SELECCIONADA INDEX MODAL CONDICIONANTE
  CVE_MODAL_CONDICIONANTE_ESTADO_INICIAL: 'INICIO',
  CVE_MODAL_CONDICIONANTE_ESTADO_NUEVA_TAREA: 'NUEVA_TAREA',

  //TOKENS
  ACCESS_TOKEN: 't',
  REFRESH_TOKEN: 'r',
  //TIPO DE GRAFICA TAREASYTD -DASHBOARD
  CVE_TAREASYTD_TIPO_GRAFICA_PORCENTAJE: 'POR_PORCENTAJE',
  DESC_TAREASYTD_TIPO_GRAFICA_PORCENTAJE: 'Por porcentaje',
  CVE_TAREASYTD_TIPO_GRAFICA_CANTIDAD: 'POR_CANTIDAD',
  DESC_TAREASYTD_TIPO_GRAFICA_CANTIDAD: 'Por cantidad',

  //PORCENTAJE Y CANTIDAD TAREAS Y AUTORIZACIONES
  CVE_TAREAS_COMPLETADAS_CANTIDAD: 'cantCompletadas',
  CVE_TAREAS_COMPLETADAS_PORCENTAJE: 'pctCompletadas',
  CVE_TAREAS_VENCIDAS_CANTIDAD: 'cantVencidas',
  CVE_TAREAS_VENCIDAS_PORCENTAJE: 'pctVencidas',

  //ESTATUS FECHA CALENDARIO SEMANAL

  CVE_ESTATUS_FECHA_TODAS: 'TODAS',
  DESC_ESTATUS_FECHA_TODAS: 'Todas',

  // TABLE-SORT
  TABLE_SORT: 'table-sort-',

  // OVERLAY-BLOCK
  OVERLAY_BLOCK: 'overlay overlay-block',

  // OVERLAY NOT ALLOWED
  NOT_ALLOWED: 'not-allowed',
}

export const AppCatalogos = {
  CAT_REGISTROS_POR_PAGINA: [
    { valor: '25', etiqueta: '25' },
    { valor: '50', etiqueta: '50' },
    { valor: '100', etiqueta: '100' },
  ],

  CATALOGOS_SELECCIONADOS: [
    {
      descripcion: AppConstantes.DESC_AUTORIZACION,
      valor: 'Autorización',
      catalogCode: AppConstantes.CAT_CODE_AUTORIZACION,
      totalOptions: 0,
    },
    {
      descripcion: AppConstantes.DESC_POSICION_CONTACTO,
      valor: 'Posición',
      catalogCode: AppConstantes.CAT_CODE_POSICION_CONTACTO,
      totalOptions: 0,
    },
    {
      descripcion: AppConstantes.DESC_PROCESO_ACTIVIDAD,
      valor: 'Actividad',
      catalogCode: AppConstantes.CAT_CODE_PROCESO_ACTIVIDAD,
      totalOptions: 0,
    },
    {
      descripcion: AppConstantes.DESC_RAZON_SOCIAL,
      valor: 'Razón Social',
      catalogCode: AppConstantes.CAT_CODE_RAZON_SOCIAL,
      totalOptions: 0,
    },
    // {
    //   descripcion: AppConstantes.DESC_LAB_GESTION_OPCIONES,
    //   valor: "Lab Gestión Gestión",
    //   catalogCode: AppConstantes.CAT_CODE_LAB_GESTION_OPCIONES,
    //   totalOptions: 0
    // },
    // {
    //   descripcion: AppConstantes.DESC_undefined,
    //   valor: "undefined",
    //   catalogCode: AppConstantes.CAT_CODE_undefined,
    //   totalOptions: 0
    // },
  ],
  //BORRAR
  CAT_ETAPA_CONDICIONANTE: [
    {
      valor: AppConstantes.CVE_ETAPA_CONDICIONANTE_EN_PROCESO,
      etiqueta: AppConstantes.DESC_ETAPA_CONDICIONANTE_EN_PROCESO,
    },
    {
      valor: AppConstantes.CVE_ETAPA_CONDICIONANTE_FINALIZADA,
      etiqueta: AppConstantes.DESC_ETAPA_CONDICIONANTE_FINALIZADA,
    },
    {
      valor: AppConstantes.CVE_ETAPA_CONDICIONANTE_VENCIDA,
      etiqueta: AppConstantes.DESC_ETAPA_CONDICIONANTE_VENCIDA,
    },
  ],

  CAT_PRIORIDAD_TAREA: [
    { valor: 'ALTA', etiqueta: 'Alta' },
    { valor: 'BAJA', etiqueta: 'Baja' },
    { valor: 'MEDIA', etiqueta: 'Media' },
  ],

  CAT_UNIDAD_PERIODICIDAD_RECORDATORIO: [
    { valor: 'ANIOS', etiqueta: 'Años' },
    { valor: 'MESES', etiqueta: 'Meses' },
    { valor: 'DIAS', etiqueta: 'Días' },
    { valor: 'HORAS', etiqueta: 'Horas' },
    { valor: 'MINUTOS', etiqueta: 'Minutos' },
  ],

  CAT_UNIDAD_DURACION_AUTORIZACION: [
    { valor: 'ANIOS', etiqueta: 'Años' },
    { valor: 'MESES', etiqueta: 'Meses' },
    { valor: 'DIAS', etiqueta: 'Días' },
  ],

  CAT_LISTA_MESES: [
    { etiqueta: 'Enero', valor: 'ENERO', numero: 0 },
    { etiqueta: 'Febrero', valor: 'FEBRERO', numero: 1 },
    { etiqueta: 'Marzo', valor: 'MARZO', numero: 2 },
    { etiqueta: 'Abril', valor: 'ABRIL', numero: 3 },
    { etiqueta: 'Mayo', valor: 'MAYO', numero: 4 },
    { etiqueta: 'Junio', valor: 'JUNIO', numero: 5 },
    { etiqueta: 'Julio', valor: 'JULIO', numero: 6 },
    { etiqueta: 'Agosto', valor: 'AGOSTO', numero: 7 },
    { etiqueta: 'Septiembre', valor: 'SEPTIEMBRE', numero: 8 },
    { etiqueta: 'Octubre', valor: 'OCTUBRE', numero: 9 },
    { etiqueta: 'Noviembre', valor: 'NOVIEMBRE', numero: 10 },
    { etiqueta: 'Diciembre', valor: 'DICIEMBRE', numero: 11 },
  ],

  CAT_LISTA_ESTATUS_CALENDARIO_SEMANAL: [
    { valor: 'TODAS', etiqueta: 'Todas', color: 'black' },
    { valor: 'VENCIDA', etiqueta: 'Vencidas', color: 'danger' },
    { valor: 'POR_VENCER', etiqueta: 'Por vencer', color: 'warning' },
    { valor: 'INICIA_HOY', etiqueta: 'Inician hoy', color: 'dodger-blue' },
    { valor: 'TERMINA_HOY', etiqueta: 'Terminan hoy', color: 'endeavour' },
  ],

  CAT_PORCENTAJE_CANTIDAD: [
    {
      etiqueta: AppConstantes.DESC_TAREASYTD_TIPO_GRAFICA_PORCENTAJE,
      valor: AppConstantes.CVE_TAREASYTD_TIPO_GRAFICA_PORCENTAJE,
    },
    {
      etiqueta: AppConstantes.DESC_TAREASYTD_TIPO_GRAFICA_CANTIDAD,
      valor: AppConstantes.CVE_TAREASYTD_TIPO_GRAFICA_CANTIDAD,
    },
  ],
}

export const AppMapas = {
  MAPA_ESTATUS_AUTORIZACION_PAGINA: new Map<string, string>([
    [AppConstantes.CVE_ESTATUS_AUTORIZACION_VENCIDA, colorDanger],
    [AppConstantes.CVE_ESTATUS_AUTORIZACION_VIGENTE, colorSuccess],
    [AppConstantes.CVE_ESTATUS_AUTORIZACION_BAJA, colorDark],
    [AppConstantes.CVE_ESTATUS_AUTORIZACION_EN_PROCESO_RENOVACION, colorNeonCarrot],
  ]),

  MAPA_ESTATUS_AUTORIZACION_DETALLE: new Map<string, string>([
    [AppConstantes.CVE_ESTATUS_AUTORIZACION_VENCIDA, colorLightDanger],
    [AppConstantes.CVE_ESTATUS_AUTORIZACION_VIGENTE, colorLightSuccess],
    [AppConstantes.CVE_ESTATUS_AUTORIZACION_BAJA, colorLightDark],
    [AppConstantes.CVE_ESTATUS_AUTORIZACION_EN_PROCESO_RENOVACION, colorLightNeonCarrot],
  ]),

  MAPA_ESTATUS_CONDICIONANTE: new Map<string, string>([
    [AppConstantes.CVE_ESTATUS_CONDICIONANTE_BAJA, colorDanger],
    [AppConstantes.CVE_ESTATUS_CONDICIONANTE_EN_PROCESO, colorSuccess],
    [AppConstantes.CVE_ESTATUS_CONDICIONANTE_COMPLETADA, colorSuccess],
    [AppConstantes.CVE_ESTATUS_CONDICIONANTE_VENCIDA, colorDanger],
  ]),

  MAPA_UNIDAD_RECORDATORIO_AUTORIZACION_DESCRIPCION: new Map<string, string>([
    [AppConstantes.CVE_UNIDAD_AUTORIZACION_RECORDATORIOS_ANIOS, 'Año/s'],
    [AppConstantes.CVE_UNIDAD_AUTORIZACION_RECORDATORIOS_MESES, 'Mes/es'],
    [AppConstantes.CVE_UNIDAD_AUTORIZACION_RECORDATORIOS_DIAS, 'día/s'],
    [AppConstantes.CVE_UNIDAD_AUTORIZACION_RECORDATORIOS_HORAS, 'Hora/s'],
    [AppConstantes.CVE_UNIDAD_AUTORIZACION_RECORDATORIOS_MINUTOS, 'Minuto/s'],
  ]),

  MAPA_UNIDAD_DURACION_AUTORIZACION_DESCRIPCIONES: new Map<string, string>([
    [AppConstantes.CVE_UNIDAD_DURACION_AUTORIZACION_DIAS, ' día/s'],
    [AppConstantes.CVE_UNIDAD_DURACION_AUTORIZACION_MESES, ' mes/es'],
    [AppConstantes.CVE_UNIDAD_DURACION_AUTORIZACION_ANIOS, ' año/s'],
  ]),

  MAPA_UNIDAD_DURACION_AUTORIZACION_DESCRIPCIONES_SINGULAR: new Map<string, string>([
    [AppConstantes.CVE_UNIDAD_DURACION_AUTORIZACION_DIAS, ' día'],
    [AppConstantes.CVE_UNIDAD_DURACION_AUTORIZACION_MESES, ' mes'],
    [AppConstantes.CVE_UNIDAD_DURACION_AUTORIZACION_ANIOS, ' año'],
  ]),
  MAPA_UNIDAD_DURACION_AUTORIZACION_DESCRIPCIONES_PLURAL: new Map<string, string>([
    [AppConstantes.CVE_UNIDAD_DURACION_AUTORIZACION_DIAS, ' días'],
    [AppConstantes.CVE_UNIDAD_DURACION_AUTORIZACION_MESES, ' meses'],
    [AppConstantes.CVE_UNIDAD_DURACION_AUTORIZACION_ANIOS, ' años'],
  ]),

  MAPA_ESTATUS_CONDICIONANTES_DESCRIPCIONES: new Map<string, string>([
    [AppConstantes.CVE_ESTATUS_CONDICIONANTE_EN_PROCESO, descEstatusEnProceso],
    [AppConstantes.CVE_ESTATUS_CONDICIONANTE_COMPLETADA, 'Completada'],
    [AppConstantes.CVE_ESTATUS_CONDICIONANTE_VENCIDA, 'Vencida'],
    [AppConstantes.CVE_ESTATUS_CONDICIONANTE_BAJA, 'Baja'],
  ]),

  MAPA_PERIODICIDAD_CONDICIONANTES_DESCRIPCIONES: new Map<string, string>([
    [
      AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_DIARIA,
      AppConstantes.DESC_PERIODICIDAD_CONDICIONANTE_DIARIA,
    ],
    [
      AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_SEMANAL,
      AppConstantes.DESC_PERIODICIDAD_CONDICIONANTE_SEMANAL,
    ],
    [
      AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_MENSUAL,
      AppConstantes.DESC_PERIODICIDAD_CONDICIONANTE_MENSUAL,
    ],
    [
      AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_TRIMESTRAL,
      AppConstantes.DESC_PERIODICIDAD_CONDICIONANTE_TRIMESTRAL,
    ],
    [
      AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_SEMESTRAL,
      AppConstantes.DESC_PERIODICIDAD_CONDICIONANTE_SEMESTRAL,
    ],
    [
      AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_ANUAL,
      AppConstantes.DESC_PERIODICIDAD_CONDICIONANTE_ANUAL,
    ],
    [
      AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_UNICA,
      AppConstantes.DESC_PERIODICIDAD_CONDICIONANTE_UNICA,
    ],
  ]),

  MAPA_PRIORIDAD_TAREA_DESCRIPCIONES: new Map<string, string>([
    [AppConstantes.CVE_PRIORIDAD_TAREA_ALTA, 'Alta'],
    [AppConstantes.CVE_PRIORIDAD_TAREA_BAJA, 'Baja'],
    [AppConstantes.CVE_PRIORIDAD_TAREA_MEDIA, 'Media'],
  ]),

  MAPA_ESTATUS_TAREA_DESCRIPCIONES: new Map<string, string>([
    [AppConstantes.CVE_ESTATUS_TAREA_EN_PROCESO, descEstatusEnProceso],
    [AppConstantes.CVE_ESTATUS_TAREA_COMPLETADA, 'Completada'],
    [AppConstantes.CVE_ESTATUS_TAREA_VENCIDA, 'Vencida'],
    [AppConstantes.CVE_ESTATUS_TAREA_BAJA, 'Baja'],
    [AppConstantes.CVE_ESTATUS_TAREA_CANCELADA, 'Cancelada'],
  ]),

  MAPA_PERIODICIDAD_CONDICIONANTE: new Map<string, string>([
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_MENSUAL, 'Mensual'],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_TRIMESTRAL, 'Trimestral'],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_SEMESTRAL, 'Semestral'],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_ANUAL, 'Anual'],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_UNICA, 'Única'],
  ]),

  //PERIODICIDADD CONDICIONANTE CALCULO UTILS
  MAPA_PERIODICIDAD_CONDICIONANTE_A_MESES: new Map<string, number>([
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_MENSUAL, 1],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_TRIMESTRAL, 3],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_SEMESTRAL, 6],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_ANUAL, 12],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_UNICA, 0],
  ]),

  MAPA_UNIDAD_DURACION_AUTORIZACION: new Map<string, ManipulateType>([
    [AppConstantes.CVE_UNIDAD_DURACION_DIAS_AUTORIZACION, 'day'],
    [AppConstantes.CVE_UNIDAD_DURACION_SEMANAS_AUTORIZACION, 'week'],
    [AppConstantes.CVE_UNIDAD_DURACION_MESES_AUTORIZACION, 'month'],
    [AppConstantes.CVE_UNIDAD_DURACION_ANIOS_AUTORIZACION, 'year'],
  ]),

  MAPA_PERIODICIDAD_CONDICIONANTE_PARA_ADD_FECHA: new Map<string, ManipulateType>([
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_DIARIA, 'day'],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_SEMANAL, 'week'],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_MENSUAL, 'month'],
    [AppConstantes.CVE_PERIODICIDAD_CONDICIONANTE_ANUAL, 'year'],
  ]),

  MAPA_PERFIL_USUARIO: new Map<string, string>([
    [AppConstantes.CVE_PERFIL_ADMINISTRADOR, 'info'],
    [AppConstantes.CVE_PERFIL_RESPONSABLE_OPERACION, 'warning'],
    //[AppConstantes.CVE_PERFIL_COORDINADOR_REGIONAL, 'warning'],
    [AppConstantes.CVE_PERFIL_OPERACION, 'endeavour'],
  ]),

  MAPA_PRIORIDAD_TAREAS: new Map<string, string>([
    [AppConstantes.CVE_PRIORIDAD_TAREA_ALTA, 'text-danger'],
    [AppConstantes.CVE_PRIORIDAD_TAREA_MEDIA, 'text-success'],
    [AppConstantes.CVE_PRIORIDAD_TAREA_BAJA, 'text-dark'],
  ]),

  MAPA_ESTATUS_TAREAS: new Map<string, string>([
    [AppConstantes.CVE_ESTATUS_TAREA_COMPLETADA, colorLightSuccess],
    [AppConstantes.CVE_ESTATUS_TAREA_EN_PROCESO, colorLightSuccess],
    [AppConstantes.CVE_ESTATUS_TAREA_VENCIDA, colorLightDanger],
    [AppConstantes.CVE_ESTATUS_TAREA_CANCELADA, 'light'],
    [AppConstantes.CVE_ESTATUS_TAREA_BAJA, 'light'],
  ]),

  MAPA_AUSENTE_TEXT: new Map<boolean, string>([
    [true, 'text-gray-800'],
    [false, 'text-gray-600'],
  ]),

  MAPA_CATALOGOS: new Map<any, any>([
    [AppConstantes.CAT_CODE_AUTORIZACION, 'AUTORIZACION'],
    [AppConstantes.CAT_CODE_RAZON_SOCIAL, 'RAZON_SOCIAL'],
    [AppConstantes.CAT_CODE_PROCESO_ACTIVIDAD, 'PROCESO_ACTIVIDAD'],
    [AppConstantes.CAT_CODE_POSICION_CONTACTO, 'POSICION_CONTACTO'],
    // [AppConstantes.CAT_CODE_LAB_GESTION_OPCIONES, 'LAB_GESTION_OPCIONES'],
    // [AppConstantes.CAT_CODE_undefined, 'undefined'],
  ]),

  MAPA_MES_NUMERO: new Map<number, string>([
    [1, 'Enero'],
    [2, 'Febrero'],
    [3, 'Marzo'],
    [4, 'Abril'],
    [5, 'Mayo'],
    [6, 'Junio'],
    [7, 'Julio'],
    [8, 'Agosto'],
    [9, 'Septiembre'],
    [10, 'Octubre'],
    [11, 'Noviembre'],
    [12, 'Diciembre'],
  ]),

  MAPA_ESTATUS_FECHA: new Map<string, string>([
    ['INICIA_HOY', 'bg-dodger-blue'],
    ['TERMINA_HOY', 'bg-endeavour'],
    ['POR_VENCER', 'bg-warning'],
    ['VENCIDA', 'bg-danger'],
  ]),
}

export const AppCodigosCatalogo = {
  RAZON_SOCIAL: 'RAZON_SOCIAL',
  ESTADOS_REPUBLICA: 'ESTADOS_REPUBLICA',
  NOMBRE_AUTORIZACION: 'AUTORIZACION',
  AUTORIZACION: 'AUTORIZACION',
  DEPENDENCIA_AUTORIZACION: 'DEPENDENCIA',
  COMPETENCIA_AUTORIZACION: 'COMPETENCIA_AUTORIZACION',
  ESTATUS_AUTORIZACION: 'ESTATUS_AUTORIZACION',
  ESTATUS_CONDICIONANTE: 'CONDICIONANTES_ESTATUS',
  PERIODICIDAD_CONDICIONANTE: 'PERIODICIDAD',
  DIVISION_NEGOCIO: 'DIVISION_NEGOCIO',
  PROCESO_ACTIVIDAD: 'PROCESO_ACTIVIDAD',
  POSICION_CONTACTO: 'POSICION_CONTACTO',
  TAREAS_PRIORIDAD: 'TAREAS_PRIORIDAD',
  TAREAS_ESTATUS: 'TAREAS_ESTATUS',
  RECORDATORIO_UNIDAD: 'RECORDATORIO_UNIDAD',
  PERFILES_USUARIOS: 'PERFILES',
}

export const AppOrdenamiento = {
  SITIOS_ATTR_NOMBRE: 'nombre',
  SITIOS_ATTR_RAZON_SOCIAL: 'razonSocial',
  SITIOS_ATTR_NRA_SEMARNAT: 'nraSemarnat',
  SITIOS_ATTR_NRA_ASEA: 'nraAsea',
  SITIOS_ATTR_DIVISION_DE_NEGOCIO: 'divisionDeNegocio',
  SITIOS_ATTR_ESTADO: 'estado',

  TAREAS_ATTR_TAREA_SITIO: 'idSitio',
  TAREAS_ATTR_TAREA_TITULO: 'titulo',
  TAREAS_ATTR_TAREA_ESTATUS: 'estatus',
  TAREAS_ATTR_TAREA_USUARIOASIGNADO: 'usuarioAsignado',
  TAREAS_ATTR_TAREA_AUTORIZACION: 'idAutorizacion',
  TAREAS_ATTR_TAREA_CONDICIONANTE: 'idCondicionante',
  TAREAS_ATTR_TAREA_FECHAINICIO: 'fechaInicio',

  AUTORIZACIONES_ATTR_NOMBRE: 'autorizacion',
  AUTORIZACIONES_ATTR_ACTIVIDAD: 'actividad',
  AUTORIZACIONES_ATTR_ID_SITIO: 'idSitio',
  AUTORIZACIONES_ATTR_COMPETENCIA: 'competencia',
  AUTORIZACIONES_ATTR_DEPENDENCIA: 'dependencia',
  AUTORIZACIONES_ATTR_FECHAINICIO: 'fecha_emision',
  AUTORIZACIONES_ATTR_FECHAVENCIMIENTO: 'fecha_vencimiento',
  AUTORIZACIONES_ATTR_FECHAULTIMARENOVACION: 'fecha_ultima_renovacion',
  AUTORIZACIONES_ATTR_FECHAPROXIMARENOVACION: 'fecha_proxima_renovacion',

  USUARIOS_ATTR_NOMBRE: 'nombre',
  USUARIOS_ATTR_PERFIL: 'perfil',
  USUARIOS_ATTR_POSICION: 'posicion',
  USUARIOS_ATTR_NEGOCIO: 'division_negocio',
}
